import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
// DataTables removed (not needed)
import RTLDefault from "views/rtl/default";
import AdminAnnouncements from "views/admin/announcements/index";
import AdminAnnouncementCreate from "views/admin/announcements/Create";
import AdminAnnouncementEdit from "views/admin/announcements/Edit";
import AdminEvents from "views/admin/events/index";
import AdminEventAttendance from "views/admin/events/Attendance";
import AdminEventCreate from "views/admin/events/Create";
import AdminEventEdit from "views/admin/events/Edit";
import AdminDocuments from "views/admin/documents/index";
import AdminDocumentCreate from "views/admin/documents/Create";
import AdminAgeGrades from "views/admin/age-grades/index";
import AdminAgeGradeCreate from "views/admin/age-grades/Create";
import AdminAgeGradeEdit from "views/admin/age-grades/Edit";
import AdminUsers from "views/admin/users/index";
import AdminUserCreate from "views/admin/users/Create";
import AdminUserEdit from "views/admin/users/Edit";
import AdminUserShow from "views/admin/users/Show";
import AdminProjects from "views/admin/projects/index";
import AdminProjectCreate from "views/admin/projects/Create";
import AdminProjectEdit from "views/admin/projects/Edit";
import AdminContacts from "views/admin/contact/index";
import AdminContactShow from "views/admin/contact/Show";
import AdminNotifications from "views/admin/notifications/index";
import AdminSettings from "views/admin/settings/index";

// Auth Imports
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

// User Imports
import UserAnnouncements from "views/user/announcements/Index";
import UserAnnouncementShow from "views/user/announcements/Show";
import UserEvents from "views/user/events/Index";
import UserEventShow from "views/user/events/Show";
import UserDocuments from "views/user/documents/Index";
import UserProfile from "views/user/profile/Index";
import ChangePassword from "views/user/change-password/Index";
import UserNotifications from "views/user/notifications/Index";
import AgeGrade from "views/user/age-grade/Index";
import UserDefault from "views/user/default/Index";
import Events from "views/user/events/Index";
import EventDetail from "views/user/events/EventDetail";

// Public Imports
import Home from "views/public/Home";
import About from "views/public/About";
import Contact from "views/public/Contact";
import Projects from "views/public/Projects";
import ProjectDetails from "views/public/ProjectDetails";
import AgeGrades from "views/public/AgeGrades";

// Icon Imports
import {
  MdHome,
  MdCampaign,
  MdEvent,
  MdDescription,
  MdPeople,
  MdPerson,
  MdNotifications,
  MdGroups,
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Home",
    layout: "/",
    path: "home",
    icon: <MdHome className="h-6 w-6" />,
    component: <Home />,
  },
  {
    name: "About",
    layout: "/",
    path: "about",
    icon: <MdHome className="h-6 w-6" />,
    component: <About />,
  },
  {
    name: "Contact",
    layout: "/",
    path: "contact",
    icon: <MdHome className="h-6 w-6" />,
    component: <Contact />,
  },
  {
    name: "Projects",
    layout: "/",
    path: "projects",
    icon: <MdHome className="h-6 w-6" />,
    component: <Projects />,
  },
  {
    name: "Project Details",
    layout: "/",
    path: "projects/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <ProjectDetails />,
  },
  {
    name: "Age Grades",
    layout: "/",
    path: "age-grades",
    icon: <MdHome className="h-6 w-6" />,
    component: <AgeGrades />,
  },
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    roles: ["admin"],
  },
  {
    name: "Announcements (Admin)",
    layout: "/admin",
    path: "announcements",
    icon: <MdCampaign className="h-6 w-6" />,
    component: <AdminAnnouncements />,
    roles: ["admin"],
  },
  {
    name: "Events (Admin)",
    layout: "/admin",
    path: "events",
    icon: <MdEvent className="h-6 w-6" />,
    component: <AdminEvents />,
    roles: ["admin"],
  },
  {
    name: "Create Event",
    layout: "/admin",
    path: "events/create",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminEventCreate />,
    roles: ["admin"],
  },
  {
    name: "Edit Event",
    layout: "/admin",
    path: "events/:id/edit",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminEventEdit />,
    roles: ["admin"],
  },
  {
    name: "Event Attendance",
    layout: "/admin",
    path: "events/:id/attendance",
    icon: <MdEvent className="h-6 w-6" />,
    component: <AdminEventAttendance />,
    roles: ["admin"],
  },
  {
    name: "Documents (Admin)",
    layout: "/admin",
    path: "documents",
    icon: <MdDescription className="h-6 w-6" />,
    component: <AdminDocuments />,
    roles: ["admin"],
  },
  {
    name: "Projects (Admin)",
    layout: "/admin",
    path: "projects",
    icon: <MdDescription className="h-6 w-6" />,
    component: <AdminProjects />,
    roles: ["admin"],
  },
  {
    name: "Age Grades (Admin)",
    layout: "/admin",
    path: "age-grades",
    icon: <MdGroups className="h-6 w-6" />,
    component: <AdminAgeGrades />,
    roles: ["admin"],
  },
  {
    name: "Upload Document",
    layout: "/admin",
    path: "documents/create",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminDocumentCreate />,
    roles: ["admin"],
  },
  {
    name: "Create Age Grade",
    layout: "/admin",
    path: "age-grades/create",
    icon: <MdGroups className="h-6 w-6" />,
    component: <AdminAgeGradeCreate />,
    roles: ["admin"],
  },
  {
    name: "Edit Age Grade",
    layout: "/admin",
    path: "age-grades/:id/edit",
    icon: <MdGroups className="h-6 w-6" />,
    component: <AdminAgeGradeEdit />,
    roles: ["admin"],
  },
  {
    name: "Create Project",
    layout: "/admin",
    path: "projects/create",
    icon: <MdDescription className="h-6 w-6" />,
    component: <AdminProjectCreate />,
    roles: ["admin"],
  },
  {
    name: "Edit Project",
    layout: "/admin",
    path: "projects/:id/edit",
    icon: <MdDescription className="h-6 w-6" />,
    component: <AdminProjectEdit />,
    roles: ["admin"],
  },
  {
    name: "Create Announcement",
    layout: "/admin",
    path: "announcements/create",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminAnnouncementCreate />,
    roles: ["admin"],
  },
  {
    name: "Edit Announcement",
    layout: "/admin",
    path: "announcements/:id/edit",
    icon: <MdHome className="h-6 w-6" />,
    component: <AdminAnnouncementEdit />,
    roles: ["admin"],
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    roles: ["admin"],
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPeople className="h-6 w-6" />,
    component: <AdminUsers />,
    roles: ["admin"],
  },
  {
    name: "Show User",
    layout: "/admin",
    path: "users/:id",
    icon: <MdPerson className="h-6 w-6" />,
    component: <AdminUserShow />,
    roles: ["admin"],
  },
  {
    name: "Contact Inquiries",
    layout: "/admin",
    path: "contact",
    icon: <MdCampaign className="h-6 w-6" />,
    component: <AdminContacts />,
    roles: ["admin"],
  },
  {
    name: "Notifications",
    layout: "/admin",
    path: "notifications",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <AdminNotifications />,
    roles: ["admin"],
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdLock className="h-6 w-6" />,
    component: <AdminSettings />,
    roles: ["admin"],
  },
  {
    name: "Create User",
    layout: "/admin",
    path: "users/create",
    icon: <MdPerson className="h-6 w-6" />,
    component: <AdminUserCreate />,
    roles: ["admin"],
  },
  {
    name: "Edit User",
    layout: "/admin",
    path: "users/:id/edit",
    icon: <MdPerson className="h-6 w-6" />,
    component: <AdminUserEdit />,
    roles: ["admin"],
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    roles: ["guest"],
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
    roles: ["guest"],
  },
  // User routes (public / user panel)
  {
    name: "User Dashboard",
    layout: "/user",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <UserDefault />,
    roles: ["user"],
  },
  {
    name: "Announcements",
    layout: "/user",
    path: "announcements",
    icon: <MdCampaign className="h-6 w-6" />,
    component: <UserAnnouncements />,
    roles: ["user"],
  },
  {
    name: "Announcement",
    layout: "/user",
    path: "announcements/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <UserAnnouncementShow />,
    roles: ["user"],
  },
  {
    name: "Events",
    layout: "/user",
    path: "events",
    icon: <MdEvent className="h-6 w-6" />,
    component: <UserEvents />,
    roles: ["user"],
  },
  {
    name: "Event",
    layout: "/user",
    path: "events/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <UserEventShow />,
    roles: ["user"],
  },
  {
    name: "Documents",
    layout: "/user",
    path: "documents",
    icon: <MdDescription className="h-6 w-6" />,
    component: <UserDocuments />,
    roles: ["user"],
  },
  {
    name: "Profile",
    layout: "/user",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <UserProfile />,
    roles: ["user"],
  },
  {
    name: "Change Password",
    layout: "/user",
    path: "change-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ChangePassword />,
    roles: ["user"],
  },
  {
    name: "Notifications",
    layout: "/user",
    path: "notifications",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <UserNotifications />,
    roles: ["user"],
  },
  {
    name: "Age Grades",
    layout: "/user",
    path: "age-grades",
    icon: <MdGroups className="h-6 w-6" />,
    component: <AgeGrade />,
    roles: ["user"],
  },
  {
    name: "RTL Admin",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
];
export default routes;
